var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "60vw", eager: "" },
      model: {
        value: _vm.value.dialog,
        callback: function($$v) {
          _vm.$set(_vm.value, "dialog", $$v)
        },
        expression: "value.dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-carousel",
            {
              attrs: {
                dark: _vm.$vuetify.theme.dark,
                "next-icon": false,
                "prev-icon": false,
                light: !_vm.$vuetify.theme.dark
              },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            },
            [
              _c(
                "v-carousel-item",
                [
                  _c(
                    "v-container",
                    [
                      _c("create-rate", {
                        ref: "create-rate",
                        on: {
                          "close-dialog": function($event) {
                            _vm.value.dialog = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }